import React from 'react';
import { Users, Target, UserX, TrendingUp, Phone, Mail, Calendar } from 'lucide-react';

const CRMDashboard = () => {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">📊 CRM Dashboard</h1>
        <p className="text-gray-600">Müşteri yönetimi özet görünümü</p>
      </div>

      {/* İstatistik Kartları */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div style={{
          padding: '20px',
          backgroundColor: 'white',
          borderRadius: '12px',
          borderLeft: '4px solid #F59E0B',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          transition: 'all 0.2s'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{
              width: '56px',
              height: '56px',
              borderRadius: '12px',
              backgroundColor: '#FEF3C7',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '28px'
            }}>🎯</div>
            <div>
              <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#F59E0B' }}>45</div>
              <div style={{ fontSize: '14px', color: '#6B7280' }}>Müşteri Adayı</div>
            </div>
          </div>
        </div>

        <div style={{
          padding: '20px',
          backgroundColor: 'white',
          borderRadius: '12px',
          borderLeft: '4px solid #10B981',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          transition: 'all 0.2s'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{
              width: '56px',
              height: '56px',
              borderRadius: '12px',
              backgroundColor: '#D1FAE5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '28px'
            }}>👥</div>
            <div>
              <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#10B981' }}>128</div>
              <div style={{ fontSize: '14px', color: '#6B7280' }}>Aktif Müşteri</div>
            </div>
          </div>
        </div>

        <div style={{
          padding: '20px',
          backgroundColor: 'white',
          borderRadius: '12px',
          borderLeft: '4px solid #EF4444',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          transition: 'all 0.2s'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{
              width: '56px',
              height: '56px',
              borderRadius: '12px',
              backgroundColor: '#FEE2E2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '28px'
            }}>💤</div>
            <div>
              <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#EF4444' }}>23</div>
              <div style={{ fontSize: '14px', color: '#6B7280' }}>Pasif Müşteri</div>
            </div>
          </div>
        </div>

        <div style={{
          padding: '20px',
          backgroundColor: 'white',
          borderRadius: '12px',
          borderLeft: '4px solid #3B82F6',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          transition: 'all 0.2s'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{
              width: '56px',
              height: '56px',
              borderRadius: '12px',
              backgroundColor: '#DBEAFE',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '28px'
            }}>📈</div>
            <div>
              <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#3B82F6' }}>196</div>
              <div style={{ fontSize: '14px', color: '#6B7280' }}>Toplam</div>
            </div>
          </div>
        </div>
      </div>

      {/* Son Aktiviteler */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        marginBottom: '24px'
      }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '16px', color: '#111827' }}>
          📅 Son Aktiviteler
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {[
            { icon: '🎯', text: 'Yeni müşteri adayı eklendi: Ahmet Yılmaz', time: '2 saat önce', color: '#F59E0B' },
            { icon: '✅', text: 'Müşteri dönüşümü tamamlandı: Mehmet Demir', time: '5 saat önce', color: '#10B981' },
            { icon: '📞', text: 'Takip görüşmesi yapıldı: Ayşe Kaya', time: '1 gün önce', color: '#3B82F6' },
            { icon: '💤', text: 'Müşteri pasife alındı: Can Özdemir', time: '2 gün önce', color: '#EF4444' },
          ].map((activity, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px',
              backgroundColor: '#F9FAFB',
              borderRadius: '8px',
              borderLeft: `3px solid ${activity.color}`
            }}>
              <span style={{ fontSize: '24px' }}>{activity.icon}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '14px', color: '#374151' }}>{activity.text}</div>
                <div style={{ fontSize: '12px', color: '#9CA3AF' }}>{activity.time}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Hızlı Aksiyonlar */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '16px', color: '#111827' }}>
          ⚡ Hızlı Aksiyonlar
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
          <button style={{
            padding: '16px',
            backgroundColor: '#EFF6FF',
            border: '1px solid #3B82F6',
            borderRadius: '8px',
            color: '#3B82F6',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'center'
          }}>
            <Target size={20} />
            Yeni Lead Ekle
          </button>
          <button style={{
            padding: '16px',
            backgroundColor: '#F0FDF4',
            border: '1px solid #10B981',
            borderRadius: '8px',
            color: '#10B981',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'center'
          }}>
            <Users size={20} />
            Yeni Müşteri Ekle
          </button>
          <button style={{
            padding: '16px',
            backgroundColor: '#FFF7ED',
            border: '1px solid #F97316',
            borderRadius: '8px',
            color: '#F97316',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'center'
          }}>
            <Phone size={20} />
            Takip Görüşmesi
          </button>
        </div>
      </div>
    </div>
  );
};

export default CRMDashboard;